<template>
  <div>
    <van-nav-bar
      :title="title"
      :left-text="$t('app.common.back')"
      left-arrow
      @click-left="$router.push('/quotes')"
      class=""
    />
    <van-list
      :key="$t('app.common.loading')"
      v-model="loadingQuotesDetails"
      :finished="finishedQuotesDetails"
      finished-text=""
      @load="onLoad"
      :loading-text="$t('app.common.loading')"
    >
      <van-row class="tableTitle">
        <van-col span="8" style="text-align: left"
          ><span>{{ columnTitleOne }}</span></van-col
        >
        <van-col span="8" style="text-align: center"
          ><span>{{ columnTitleTwo }}</span></van-col
        >
        <van-col span="8" style="text-align: right"
          ><span>{{ columnTitleThree }}</span></van-col
        >
      </van-row>
      <div v-for="(item, index) in dataList" :key="index" @click="onItem(item)">
        <van-row class="tablecontent"
          ><van-col span="8"
            ><span>{{ item.name }}<br />{{ item.code }}</span></van-col
          >
          <van-col span="8" style="padding-top: 10px; text-align: center"
            ><span
              v-bind:class="[
                item.zhi3.substring(0, 1) == '-' ? 'greenText' : 'redText',
              ]"
              >{{ item.zhi1 }}</span
            ></van-col
          >
          <van-col span="8" style="padding-top: 10px; text-align: right"
            ><span
              v-bind:class="[
                item.zhi3.substring(0, 1) == '-' ? 'greenText' : 'redText',
              ]"
              >{{
                item.zhi2 !== null
                  ? item.zhi2
                  : "--"
              }}</span
            ></van-col
          >
        </van-row>
      </div>
    </van-list>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  name: "QuotesDetails",
  data() {
    return {
      title: "",
      dataList: "",
      quotesId: sessionStorage.getItem("quotesId"),
      loadingQuotesDetails: false,
      finishedQuotesDetails: false,
      page: 1,
      columnTitleOne: "",
      columnTitleTwo: "",
      columnTitleThree: "",
    };
  },
  methods: {
    onItem(item) {
      this.$router.push({
        name: "Kline",
        params: { code: item.code, shortCode: item.shortCode, short: item.short },
      });
    },
    get_all_stock() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
            
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=symbol&asc=1&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_top_gainers() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
            sort_field:"chg",
            sort_order:"desc"
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=symbol&asc=1&node=hot_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_top_losers() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
             sort_field:"chg",
            sort_order:"asc"
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=changepercent&asc=0&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_market_cap() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
             sort_field:"totalMarketValue",
            sort_order:"desc"

          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=changepercent&asc=1&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_24th_volume() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
            sort_field:"tradingVolume",
            sort_order:"desc"
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=amount&asc=0&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    get_long_trading() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
            sort_field:"longTradingStocks",
            sort_order:"desc"
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                if (!e.total) {
                  that.dataList.push(e);
                }
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
    },
    get_short_trading() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "all_stock",
            page: that.page,
            num: 40,
            sort_field:"shortTradingStocks",
            sort_order:"desc"
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                if (!e.total) {
                  that.dataList.push(e);
                }
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
    },
    get_hk_volume() {
      let that = this;
      that.loadingQuotesDetails = true;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "stock_page_data",
            action: "stock_hk_volume",
            page: that.page,
            num: 40,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            if (res.data.data.length == 0) {
              that.finishedQuotesDetails = true;
            } else {
              res.data.data.forEach((e) => {
                that.dataList.push(e);
              });
              that.page++;
            }
            that.loadingQuotesDetails = false;
          } else if (res.data.code == 0) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .finally(() => {
          that.loadingQuotesDetails = false;
        });
      // $.ajax({
      //   cache: true,
      //   url:
      //     "https://vip.stock.finance.sina.com.cn/quotes_service/api/json_v2.php/Market_Center.getHKStockData?page=" +
      //     that.pageCount +
      //     "&num=40&sort=volume&asc=0&node=qbgg_hk&_s_r_a=init",
      //   type: "GET",
      //   dataType: "json",
      //   success: function (data) {
      //     if (data.length == 0) {
      //       that.finishedQuotesDetails = true;
      //       return;
      //     }
      //     data.forEach((i) => {
      //       that.list.push(i);
      //     });
      //     that.loadingQuotesDetails = false;
      //     that.pageCount++;
      //   },
      // });
    },
    onLoad() {
      let quotesID = this.quotesId;
      if (quotesID == 1) {
        this.get_all_stock();
        this.title = this.$t('app.quotes_detail.title1');
        this.columnTitleOne = this.$t('app.quotes_detail.name');
        this.columnTitleTwo = this.$t('app.quotes_detail.latest_price');
        this.columnTitleThree = this.$t('app.quotes_detail.rise');
      } else if (quotesID == 2) {
        this.get_top_gainers();
        this.title = this.$t('app.quotes.top_gainers');
        this.columnTitleOne = this.$t('app.quotes_detail.name');
        this.columnTitleTwo = this.$t('app.quotes_detail.latest_price');
        this.columnTitleThree = this.$t('app.quotes_detail.rise');
      } else if (quotesID == 3) {
        this.get_top_losers();
        this.title = this.$t('app.quotes.top_losers');
        this.columnTitleOne = this.$t('app.quotes_detail.name');
        this.columnTitleTwo = this.$t('app.quotes_detail.latest_price');
        this.columnTitleThree = this.$t('app.quotes_detail.rise');
      } else if (quotesID == 4) {
        this.get_market_cap();
        this.title = this.$t('app.quotes.market_cap');
        this.columnTitleOne = this.$t('app.quotes_detail.name');
        this.columnTitleTwo = this.$t('app.quotes_detail.latest_price');
        this.columnTitleThree = this.$t('app.quotes_detail.rise');
      } else if (quotesID == 5) {
        this.get_24th_volume();
        this.title = this.$t('app.quotes.24h_volume');
        this.columnTitleOne = this.$t('app.quotes_detail.name');
        this.columnTitleTwo = this.$t('app.quotes_detail.latest_price');
        this.columnTitleThree = this.$t('app.quotes_detail.volume1');
      } else if (quotesID == 6) {
        this.get_long_trading();
        this.title = this.$t('app.quotes.long_trading_stocks');
        this.columnTitleOne = this.$t('app.quotes_detail.name');
        this.columnTitleTwo = this.$t('app.quotes_detail.latest_price');
        this.columnTitleThree = this.$t('app.quotes_detail.volume2');
      } else if (quotesID == 7) {
        this.get_short_trading();
        this.title = this.$t('app.quotes.short_trading_stocks');
        this.columnTitleOne = this.$t('app.quotes_detail.name');
        this.columnTitleTwo = this.$t('app.quotes_detail.latest_price');
        this.columnTitleThree = this.$t('app.quotes_detail.volume2');
      } else {
      }
    },
  },
  mounted: function () {
    this.dataList = [];
    this.finishedQuotesDetails = false;
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.tablecontent {
  font-size: 14px;
  padding: 10px;
}
.tableTitle {
  font-size: 14px;
  padding-top: 5px;
  padding-left: 10px;
  padding-right: 10px;
  font-weight: bold;
}
.redText {
  color: #ff2c27;
}
.greenText {
  color: #008000;
}
</style>



// WEBPACK FOOTER //
// src/components/QuotesDetails.vue